(function() {
  function initTrendingSeason(section) {
    const isDesktopGrid = section.classList.contains("desktop-grid");
    const isMobileGrid = section.classList.contains("mobile-grid");

    if(isDesktopGrid || (window.innerWidth<768 && isMobileGrid)
    ){

    return;

    }

    if (!section) return;
    const track = section.querySelector(".ts-track");
    const next = section.querySelector(".ts-next");
    const prev = section.querySelector(".ts-prev");
    if (!track) return;
    /* -------------------
    SETTINGS
    ------------------- */
    const autoplay =
    section.dataset.autoplay === "true";

    const autoplaySpeed =
    Number(
    section.dataset.speed
    ) || 3500;
    let auto;
    let dragging = false;
    let startX = 0;
    let scrollLeft = 0;
    /* -------------------
    ARROWS
    ------------------- */
    function cardWidth() {
      const card =
        track.querySelector(".ts-card");
      if (!card) return 500;
      return card.offsetWidth + 20;
    }

    function nextSlide() {
      track.scrollBy({
        left: cardWidth(),
        behavior: "smooth"
      });
    }

    function prevSlide() {
      track.scrollBy({
        left: -cardWidth(),
        behavior: "smooth"
      });
    }
    if (next) {
      next.addEventListener(
        "click",
        nextSlide
      );
    }
    if (prev) {
      prev.addEventListener(
        "click",
        prevSlide
      );
    }
    /* -------------------
    AUTOPLAY
    ------------------- */
    function startAuto() {
      if (!autoplay) return;
      stopAuto();
      auto = setInterval(() => {
        if (
          track.scrollLeft +
          track.clientWidth >=
          track.scrollWidth - 50
        ) {
          track.scrollTo({
            left: 0,
            behavior: "smooth"
          });
        } else {
          nextSlide();
        }
      }, autoplaySpeed);
    }

    function stopAuto() {
      clearInterval(auto);
    }
    startAuto();
    section.addEventListener(
      "mouseenter",
      stopAuto
    );
    section.addEventListener(
      "mouseleave",
      startAuto
    );
    /* -------------------
    DRAG
    ------------------- */
    track.addEventListener(
      "mousedown",
      (e) => {
        dragging = true;
        startX = e.pageX;
        scrollLeft = track.scrollLeft;
        track.style.cursor = "grabbing";
      }
    );
    window.addEventListener(
      "mouseup",
      () => {
        dragging = false;
        track.style.cursor = "grab";
      }
    );
    track.addEventListener(
      "mousemove",
      (e) => {
        if (!dragging) return;
        e.preventDefault();
        const move =
          (e.pageX - startX) * 1.5;
        track.scrollLeft =
          scrollLeft - move;
      }
    );
    /* -------------------
    TOUCH
    ------------------- */
    track.addEventListener(
      "touchstart",
      (e) => {
        startX =
          e.touches[0].pageX;
        scrollLeft =
          track.scrollLeft;
      }
    );
    track.addEventListener(
      "touchmove",
      (e) => {
        const move =
          e.touches[0].pageX -
          startX;
        track.scrollLeft =
          scrollLeft -
          move;
      }
    );
    /* -------------------
    MOUSE WHEEL
    ------------------- */
    // track.addEventListener(
    //   "wheel",
    //   (e) => {
    //     if (
    //       Math.abs(
    //         e.deltaY
    //       ) >
    //       Math.abs(
    //         e.deltaX
    //       )
    //     ) {
    //       e.preventDefault();
    //       track.scrollLeft +=
    //         e.deltaY;
    //     }
    //   }, {
    //     passive: false
    //   }
    // );
    /* -------------------
    QUICK ADD
    ------------------- */
    section
      .querySelectorAll(
        ".ts-quick-add"
      )
      .forEach(
        (button) => {
          button.addEventListener(
            "click",
            async function(e) {
              e.preventDefault();
              e.stopPropagation();
              const id =
                this.dataset.product;
              if (!id)
                return;
              try {
                this.disabled = true;
                this.innerHTML = "✓";
                await fetch(
                  "/cart/add.js", {
                    method: "POST",
                    headers: {
                      "Content-Type": "application/json"
                    },
                    body: JSON.stringify({
                      id: id,
                      quantity: 1
                    })
                  }
                );
                document.dispatchEvent(
                  new CustomEvent(
                    "cart:refresh"
                  )
                );
                setTimeout(() => {
                  this.innerHTML = "＋";
                  this.disabled = false;
                }, 1200);
              } catch {
                this.innerHTML = "!";
                setTimeout(() => {
                  this.innerHTML = "＋";
                  this.disabled = false;
                }, 1200);
              }
            });
        }
      );
    /* -------------------
    KEYBOARD
    ------------------- */
    window.addEventListener(
      "keydown",
      (e) => {
        if (
          document.activeElement &&
          document.activeElement.tagName ===
          "INPUT"
        ) return;
        if (e.key === "ArrowRight")
          nextSlide();
        if (e.key === "ArrowLeft")
          prevSlide();
      });
  }
  /* -------------------
  LOAD
  ------------------- */
  document.addEventListener(
    "DOMContentLoaded",
    function() {
      document
        .querySelectorAll(
          ".ts-section"
        )
        .forEach(
          initTrendingSeason
        );
    }
  );
  /* -------------------
  SHOPIFY EDITOR
  ------------------- */
  document.addEventListener(
    "shopify:section:load",
    function(e) {
      initTrendingSeason(
        e.target
      );
    }
  );
})();